export default __webpack_public_path__ + "static/media/sweetbloom.9a9c6534.png";